"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";
import { GraduationCap } from "lucide-react";
import { ThemeToggle } from "@/components/theme-toggle";
import { getUser } from "@/lib/api";

export function MainNav(
  props: React.HTMLAttributes<HTMLElement>
) {
  const pathname = usePathname();
  // 直接从getUser获取角色，避免在effect中setState
  const user = typeof window !== 'undefined' ? getUser() : null;
  const userRole = user?.role || null;

  // 根据用户角色动态生成路由
  const getRoutes = () => {
    const routes = [
      {
        href: "/",
        label: "首页",
        active: pathname === "/",
        show: true,
      },
    ];

    // teacher等同于admin，拥有所有权限
    const isTeacher = userRole === 'teacher' || userRole === 'admin';
    
    // 学生可以看到学生端
    if (userRole === 'student') {
      routes.push({
        href: "/student",
        label: "学生端",
        active: pathname?.startsWith("/student") || false,
        show: true,
      });
    }

    // 教师（等同于admin）可以看到教师端
    if (isTeacher) {
      routes.push({
        href: "/teacher",
        label: "教师端",
        active: pathname?.startsWith("/teacher") || false,
        show: true,
      });
    }

    // 未登录用户显示所有选项（但点击后会被重定向）
    if (!userRole) {
      routes.push(
        {
          href: "/student",
          label: "学生端",
          active: pathname?.startsWith("/student") || false,
          show: true,
        },
        {
          href: "/teacher",
          label: "教师端",
          active: pathname?.startsWith("/teacher") || false,
          show: true,
        }
      );
    }

    return routes.filter(route => route.show);
  };

  const routes = getRoutes();

  return (
    <div className="flex items-center space-x-6" {...props}>
      <Link href="/" className="flex items-center space-x-2">
        <GraduationCap className="h-6 w-6 text-blue-600 dark:text-blue-400" />
        <span className="hidden font-bold sm:inline-block">
          在线考试系统
        </span>
      </Link>
      <nav className="flex items-center space-x-4 lg:space-x-6">
        {routes.map((route) => (
          <Link
            key={route.href}
            href={route.href}
            className={cn(
              "text-sm font-medium transition-colors hover:text-primary",
              route.active
                ? "text-black dark:text-white"
                : "text-muted-foreground"
            )}
          >
            {route.label}
          </Link>
        ))}
        <ThemeToggle />
      </nav>
    </div>
  );
}
